import { z } from "zod";

import { selectionValidationErrorSchema } from "@/schemas/routing/selection-validation";

const apiBatchStatuses = [
	"Unknown",
	"Staged",
	"ProducingNext",
	"Triggered",
	"ProducingNow",
	"Selected",
	"Paused",
	"Pausing",
	"Completed",
	"Canceled",
] as const;

export const apiBatchStatusSchema = z.enum(apiBatchStatuses);

export type BatchStatus = z.infer<typeof apiBatchStatusSchema>;

export const batchSchema = z.object({
	alias: z.string().default(""),
	batchId: z.string().default(""),
	licensePlateNumber: z.string().nullable(),
	status: apiBatchStatusSchema.default("Unknown"),
	quantity: z.number().default(0),
	packStation: z.string().nullable(),
	cartonCountPerJob: z.number().default(0),
	labelCountPerJob: z.number().default(0),
	cartonDimension: z
		.object({
			Length: z.number().default(0),
			Width: z.number().default(0),
			Height: z.number().default(0),
		})
		.nullable(),
	optimalZFoldNames: z.array(z.string()).default([]),
	stagedCount: z.number().default(0),
	selectedCount: z.number().default(0),
	completedCount: z.number().default(0),
	removedCount: z.number().default(0),
	lastUpdatedUTC: z.string().default(""),
	blockedReason: selectionValidationErrorSchema.nullable(),
});

export const pageOfBatchesSchema = z.object({
	results: z.array(batchSchema),
	totalResults: z.number(),
});

export type BatchBlockedReason = z.infer<typeof selectionValidationErrorSchema>;
export type Batch = z.infer<typeof batchSchema>;
export type PageOfBatches = z.infer<typeof pageOfBatchesSchema>;
